import { weijuProblems } from '@/mocks/weiju';
import Reveal from '@/components/base/Reveal';

export default function Problems() {
  return (
    <section id="problems" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 border border-secondary-200 text-xs md:text-sm">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500"></span>
              解决什么问题
            </div>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              传统餐饮及供应链业务存在四类痛点
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              味聚通过一个数字化平台，把消费端、餐饮端、供应链端和平台管理端连接起来，解决各自分散、割裂的问题。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {weijuProblems.map((group, idx) => (
            <Reveal key={group.role} delay={idx * 80}>
              <div className="h-full p-6 rounded-lg bg-background-50 border border-background-200">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${group.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{group.role}</h3>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{group.desc}</p>
                <ul className="mt-4 space-y-2">
                  {group.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm text-foreground-700 leading-relaxed">
                      <i className="ri-close-circle-line text-foreground-400 mt-0.5"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}